export interface IFindAllGrpcRequest {
    filter?: string;
    sort?: string;
    limit?: number;
    page?: number;
    populate?: string[];
    autoPopulate?: boolean;
}
export interface IFindByIdGrpcRequest {
    id: string;
    populate?: string[];
    autoPopulate?: boolean;
}

export interface IFindAllHttpRequest {
    filter?: Record<string, unknown>;
    limit?: string;
    page?: string;
}
